import React from "react";
import Select, { SingleValue } from "react-select";
import { LojaOption } from "../types";
import { SELECT_STYLES, LABEL_CLASS } from "../constants";

interface LojaFilterProps {
  lojaOptions: LojaOption[];
  selectedLojaOption: LojaOption | null;
  onLojaChange: (option: SingleValue<LojaOption>) => void;
}

const LojaFilter: React.FC<LojaFilterProps> = ({
  lojaOptions,
  selectedLojaOption,
  onLojaChange,
}) => {
  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
      <label htmlFor="loja-select" className={LABEL_CLASS}>
        Loja:
      </label>
      <Select<LojaOption>
        inputId="loja-select"
        value={selectedLojaOption}
        onChange={onLojaChange}
        options={lojaOptions}
        isClearable
        placeholder="Todas"
        className="w-full sm:w-60 md:w-60"
        styles={SELECT_STYLES}
      />
    </div>
  );
};

export default LojaFilter;
